import { BackupCircleSVG } from '../../../svgComponents/backupCircleSVG';
import { CloseCircleSVG } from '../../../svgComponents/closeCircleSVG';
import { TickCircleSVG } from '../../../svgComponents/tickCircleSVG';

export const repaymentOptions = [
    {
        value: 'disabled',
        label: 'No',
        description:
            "You'll be able to make one-off repayments manually using this card",
        icon: <CloseCircleSVG />
    },
    {
        value: 'primary',
        label: 'Primary repayment method',
        description:
            "We'll collect your repayments automatically. If a payment fails, we'll try again, as set our in your credit agreement",
        icon: <TickCircleSVG />
    },
    {
        value: 'backup',
        label: 'Backup repayment method',
        description:
            "We'll try to take a payment from your backup card if your primary payment method fails (e.g. if the card is blocked by your bank)",
        icon: <BackupCircleSVG />
    }
];
